import type { InsiderTransation } from '@/pages/CompanyReport/components/InsiderTradingTransactions/redux/selectors';
import { DeprecatedTruncator } from '@/components/Truncator';
import {
  Roles,
  RolesWithTitles,
  TransactionValue,
} from '@/pages/CompanyReport/components/InsiderTradingTransactions';
import {
  Accordion,
  Header,
  Body,
  Date,
  Owner,
  OwnerName,
  ChevronRight,
  ChevronDown,
  TransactionTypePositioned,
} from './styled';
import { useTracking } from 'react-tracking';

export interface CardsProps {
  data: InsiderTransation[];
  handleClick: (index: number) => void;
  active: number[];
}

const Cards = ({ data, handleClick, active }: CardsProps) => {
  const { trackEvent } = useTracking({ type: 'track' });
  return (
    <>
      {data.map((n, index) => {
        const open = active.includes(index);
        const {
          filingDate,
          shares,
          priceMax,
          ownerName,
          boardTitle,
          teamTitle,
          ownerType,
          transactionType,
          transactionValue,
        } = n;
        return (
          <Accordion
            key={`InsiderTradingAccordionRow-${ownerName}-${shares}-${index}`}
          >
            <Header
              onClick={() => {
                handleClick(index);
                trackEvent({
                  action: 'click',
                  modifier: 'transaction',
                  index,
                  ownerName,
                  ownerType,
                  teamTitle,
                  boardTitle,
                  transactionType,
                  transactionValue,
                });
              }}
            >
              <TransactionTypePositioned type={transactionType}>
                {transactionType}
              </TransactionTypePositioned>
              <TransactionValue type={transactionType}>
                {transactionValue}
              </TransactionValue>
              <Date>{filingDate}</Date>
              <Owner>
                <OwnerName>{ownerName}</OwnerName>
                {(boardTitle || teamTitle) && (
                  <Roles boardTitle={boardTitle} teamTitle={teamTitle} />
                )}
              </Owner>
              {!open && <ChevronRight />}
              {open && <ChevronDown />}
            </Header>
            <DeprecatedTruncator
              open={open}
              minHeight={0}
              animationDuration={0.4}
            >
              <Body>
                <tbody>
                  <tr>
                    <td>
                      <span>Entity</span>
                    </td>
                    <td>{ownerType}</td>
                  </tr>
                  {boardTitle || teamTitle ? (
                    <tr>
                      <td>
                        <span>Role</span>
                      </td>
                      <td>
                        <RolesWithTitles
                          boardTitle={boardTitle}
                          teamTitle={teamTitle}
                        />
                      </td>
                    </tr>
                  ) : null}
                  <tr>
                    <td>
                      <span>Shares</span>
                    </td>
                    <td>{shares}</td>
                  </tr>
                  <tr>
                    <td>
                      <span>Max Price</span>
                    </td>
                    <td>{priceMax}</td>
                  </tr>
                </tbody>
              </Body>
            </DeprecatedTruncator>
          </Accordion>
        );
      })}
    </>
  );
};

export default Cards;
